import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market_s",
  "use": "icon-market_s-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-market_s\">\n<path d=\"M100,11.4c-23.4,0-44.7,9.2-60.6,24l48.7,48.2c1.8,1.8,2.6,4.3,2.2,6.5c-0.4,2.3-2.1,4-4.4,4.4c-2.2,0.5-4.7-0.3-6.5-2.1\n\tL31.1,44.5C18.7,59.7,11.4,79.1,11.4,100c0,48.8,39.7,88.6,88.6,88.6s88.6-39.7,88.6-88.5S148.8,11.4,100,11.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol